var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 0C6.793 0 2.571 4.324 2.571 9.659v5.268H0v17.56C0 34.428 1.535 36 3.429 36H20.57C22.465 36 24 34.427 24 32.488V14.927h-2.571V9.659C21.429 4.324 17.207 0 12 0zm7.714 14.927V9.659c0-4.365-3.453-7.903-7.714-7.903-4.26 0-7.714 3.538-7.714 7.903v5.268zm-6.856 10.386a2.632 2.632 0 001.714-2.484c0-1.455-1.152-2.634-2.572-2.634-1.42 0-2.571 1.179-2.571 2.634 0 1.147.716 2.123 1.715 2.484v3.663h1.714z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

export default SvgLockIcon;